module.exports = __webpack_public_path__ + "img/1700015816247056003.3d7177b4.png";